import React from "react";

//PropTypes
import PropTypes from "prop-types";

//MUI components
import { Menu } from "@mui/icons-material";
import { IconButton } from "@mui/material";

function MenuIcon({ setOpen }) {
  // ==========>Component<==========
  return (
    <IconButton id="menubutton" color="primary" onClick={() => setOpen(true)}>
      <Menu sx={{ fontSize: "30px" }} />
    </IconButton>
  );
}

// ==========>Component PropTypes<==========
MenuIcon.propTypes = {
  setOpen: PropTypes.func.isRequired,
};

export default MenuIcon;
